import { flaggedFilter } from 'owa-locstrings/lib/strings/flaggedfilter.locstring.json';
import { unreadFilter } from 'owa-locstrings/lib/strings/unreadfilter.locstring.json';
import { allFilter, toMeFilter, mentionsFilter } from '../strings.locstring.json';
import { attachmentsLabel } from 'owa-locstrings/lib/strings/attachmentslabel.locstring.json';
import loc from 'owa-localize';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';

import { assertNever } from 'owa-assert';
import { trace } from 'owa-trace';

export default function getViewFilterDisplay(filter: ViewFilter): string {
    switch (filter) {
        case 'All':
            return loc(allFilter);
        case 'Unread':
            return loc(unreadFilter);
        case 'Flagged':
            return loc(flaggedFilter);
        case 'ToOrCcMe':
            return loc(toMeFilter);
        case 'HasAttachment':
            return loc(attachmentsLabel);
        case 'Mentioned':
            return loc(mentionsFilter);
        case 'TaskActive':
        case 'TaskOverdue':
        case 'TaskCompleted':
        case 'DeprecatedSuggestions':
        case 'DeprecatedSuggestionsRespond':
        case 'DeprecatedSuggestionsDelete':
        case 'DeprecatedNoClutter':
        case 'DeprecatedClutter':
        case 'SystemCategory':
        case 'UserCategory':
        case 'Pinned':
        case 'Focused':
        case 'Locked':
        case 'Hashtag':
        case 'Liked':
            trace.error('Filter not implemented');
            return '';

        default:
            return assertNever(filter);
    }
}
